import { apiClient } from "./api-client";
import type {
  ScoringRule,
  ScoringRuleInput,
  ScoringRulesResponse,
  SaveScoringRulesRequest,
  SaveScoringRulesResponse,
  ScoringPreviewResponse,
} from "../types/scoring-rules";

export interface BulkUpdateGroup {
  answerId: string;
  questionId: string;
  rules: ScoringRuleInput[];
}

export interface BulkUpdateScoringRulesResponse {
  updatedGroups: Record<string, ScoringRule[]>;
}

export async function fetchScoringRulesByQuiz(
  quizId: string,
): Promise<ScoringRulesResponse> {
  return apiClient<ScoringRulesResponse>(`/admin/scoring-rules/quiz/${quizId}`);
}

export async function saveScoringRulesForAnswer(
  answerId: string,
  body: SaveScoringRulesRequest,
): Promise<SaveScoringRulesResponse> {
  return apiClient<SaveScoringRulesResponse>(
    `/admin/scoring-rules/answer/${answerId}`,
    {
      method: "PUT",
      body: JSON.stringify(body),
    },
  );
}

export async function bulkUpdateScoringRules(
  quizId: string,
  updates: BulkUpdateGroup[],
): Promise<BulkUpdateScoringRulesResponse> {
  return apiClient<BulkUpdateScoringRulesResponse>(
    `/admin/scoring-rules/quiz/${quizId}/bulk-update`,
    {
      method: "POST",
      body: JSON.stringify({ updates }),
    },
  );
}

export async function previewScoringResults(
  quizId: string,
  selectedAnswers: Record<string, string>,
  limit?: number,
): Promise<ScoringPreviewResponse> {
  return apiClient<ScoringPreviewResponse>(
    `/admin/scoring-rules/quiz/${quizId}/preview`,
    {
      method: "POST",
      body: JSON.stringify({ selectedAnswers, limit }),
    },
  );
}

export interface RenameQuestionKeyResponse {
  affectedCount: number;
  oldKey: string;
  newKey: string;
}

export async function renameQuestionKey(
  quizId: string,
  oldKey: string,
  newKey: string,
): Promise<RenameQuestionKeyResponse> {
  return apiClient<RenameQuestionKeyResponse>(
    `/admin/scoring-rules/quiz/${quizId}/rename-question-key`,
    {
      method: "POST",
      body: JSON.stringify({ oldKey, newKey }),
    },
  );
}
